import { AppraisalImplementationFileDocumentTypes, AppraisalOrderTypes, AppraisalPurposes } from '../enums';

export interface RelatedDeliverableDto {
  id: number;
  appraisalDocumentType: AppraisalImplementationFileDocumentTypes;
  orderTypes: AppraisalOrderTypes[];
  purposes: AppraisalPurposes[];
  isAutogenerated: boolean;
}
